import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Box, IconButton, Paper, Typography,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { SUPER_ADMIN } from '../../utils/const/user';
import Changes from '../../components/UploadView/Changes';

import { updateLocationUsersChanges, uploadLocationUsersFile } from '../../requests/api/user-locations';

import useStyles from './styles';

function LocationUsersImportView() {
  const classes = useStyles();
  const { t } = useTranslation();

  const account = useSelector((state) => state.account);
  const [uploadDifference, setUploadDifference] = useState(null);

  if (account.user.role !== SUPER_ADMIN) {
    window.location.href = '/home';
  }

  const tableHeaders = [
    {
      id: 'location',
      label: t('locations.importViews.locationUsers.location'),
    },
    {
      id: 'userName',
      label: t('locations.importViews.locationUsers.user'),
    },
    {
      id: 'userEmail',
      label: t('locations.importViews.locationUsers.email'),
    },
  ];

  const properties = ['Location', 'UserName', 'UserEmail'];

  // Instructions data for the template.
  const instructions = [
    ['Instrucciones'],
    ['1. Completa la hoja "Sucursales-Usuarios" con los datos de sucursales y usuarios.'],
    ['2. En la columna "location" agrega los códigos internos de las sucursales y en la columna "email" agrega el email de los usuarios.'],
    ['3. Si el código interno de la sucursal es un número verificar que la información se guarde en formato texto.'],
    ['4. Guarda el archivo en formato xlsx o csv (con delimitador ",").'],
    [],
    [],
    // Example data
    ['Ejemplo'],
    ['location', 'email'],
    ['108032', 'usuario@mail.com'],
    ['J512', 'usuario2@mail.com'],
  ];

  return (
    <div className={classes.content}>
            <Box className={classes.backButton}>
        <IconButton component={Link} to={'../../../locations'}>
          <ArrowBackIcon/>
        </IconButton>
        <Typography className={classes.title} variant="h3" color="textPrimary">
        {t('locations.importViews.locationUsers.uploadFile')}
      </Typography>
      </Box>
      <Box className={classes.noteContainer}>
        <Typography variant="p" color="textPrimary">
          {t('locations.importViews.locationUsers.fileNote')}
          <br />
          {t('locations.importViews.references')}
        </Typography>
        <Box className={classes.referenceBox}>
          <div className={classes.referenceNew} /> {t('locations.importViews.new')}
        </Box>
        <Box className={classes.referenceBox}>
          <div className={classes.referenceEqual} /> {t('locations.importViews.equal')}
        </Box>
        <Box className={classes.referenceBox}>
          <div className={classes.referenceDelete} /> {t('locations.importViews.delete')}
        </Box>
      </Box>
      <Paper className={classes.changesTable}>
        <Changes
          properties={properties}
          templateColumns={['location', 'email']}
          templateName="location-users"
          templateSheetName="Sucursales-Usuarios"
          instructions={instructions}
          tableHeaders={tableHeaders}
          uploadDifference={uploadDifference || []}
          setUploadDifference={setUploadDifference}
          updateFunction={updateLocationUsersChanges}
          uploadFunction={uploadLocationUsersFile}
        />
      </Paper>
    </div>
  );
}

export default LocationUsersImportView;
